/*
  derimarket.net - SEO uyumlu "Daha Fazla Göster" linki (23.10.2026)

  snippets/pagination.liquid içindeki <a data-load-more-link href="(sonraki sayfa)"> linki için.
  - Google, href adresini normal bir link olarak takip eder.
  - Ziyaretçi tıkladığında sayfa değişmez; sonraki sayfanın ürünleri,
    temanın eski butonunda olduğu gibi listenin altına eklenir.
  - Ürünler eklendikten sonra adres çubuğu yüklenen sayfaya (ör. ...?page=2) güncellenir.
    Yeni geçmiş kaydı açılmaz, geri tuşu davranışı değişmez.
  - Sayfada "Sayfa 3 / 7" göstergesi varsa (sections/main-collection-product-grid.liquid) o da güncellenir.
  - Bir hata olursa veya JavaScript çalışmazsa link normal şekilde sonraki sayfayı açar.
*/
(function () {
  if (window.__dmLoadMoreLink) return;
  window.__dmLoadMoreLink = true;

  function getSectionId(el) {
    if (window.FoxTheme && FoxTheme.utils && typeof FoxTheme.utils.getSectionId === 'function') {
      try { return FoxTheme.utils.getSectionId(el); } catch (e) {}
    }
    var section = el.closest('[id^="shopify-section-"]');
    return section ? section.id.replace('shopify-section-', '') : '';
  }

  function load(link) {
    if (link.classList.contains('btn--loading')) return;
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) { window.location.href = link.href; return; }

    link.classList.add('pointer-events-none');
    link.classList.add('btn--loading');

    var pageUrl = link.href;
    var url = new URL(pageUrl, window.location.origin);
    var sectionId = getSectionId(link);
    if (sectionId) url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var list = grid.querySelector('.products-list');
        var newList = doc.querySelector('.products-list');
        if (list && newList) {
          newList.querySelectorAll('.f-column').forEach(function (item) {
            list.appendChild(item);
          });
        }

        var pagination = grid.querySelector('.pagination');
        var newPagination = doc.querySelector('.pagination');
        if (pagination) {
          if (newPagination) {
            pagination.innerHTML = newPagination.innerHTML;
          } else {
            pagination.remove();
          }
        }

        // Adres çubuğunu yüklenen sayfaya güncelle (yeni geçmiş kaydı oluşturmadan)
        try {
          if (window.history && typeof history.replaceState === 'function') {
            history.replaceState(history.state, '', pageUrl);
          }
        } catch (e) {}

        // Sayfa göstergesini (ör. "Sayfa 3 / 7") yüklenen sayfaya güncelle
        var indicator = document.querySelector('[data-dm-page-indicator]');
        if (indicator) {
          var pageNumber = new URL(pageUrl, window.location.origin).searchParams.get('page');
          var template = indicator.getAttribute('data-template');
          if (pageNumber && template) {
            indicator.textContent = template
              .replace('__N__', pageNumber)
              .replace('__T__', indicator.getAttribute('data-total') || '');
          }
        }

        observeInfinite();
      })
      .catch(function () {
        window.location.href = pageUrl;
      });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-load-more-link]');
    if (!link) return;
    // Ctrl/Cmd/Shift ile tıklanırsa (yeni sekmede açma) normal link davranışı korunur
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    load(link);
  });

  // Tema ayarında "sonsuz kaydırma" seçilirse: link görünür olunca otomatik yükle
  var observer = null;
  function observeInfinite() {
    if (!('IntersectionObserver' in window)) return;
    var link = document.querySelector('a[data-load-more-link][data-type="infinite"]');
    if (!link) return;
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            load(entry.target);
          }
        });
      }, { rootMargin: '200px 0px 200px 0px' });
    }
    observer.observe(link);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeInfinite);
  } else {
    observeInfinite();
  }
})();
